module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><div><h4>'+
((__t=( term ))==null?'':__t)+
' </h4><hr><dl> ';
 if ( zone ) { 
__p+=' <dt> '+
((__t=(i18n.tc('ControlAccessories', 'Zone: ')))==null?'':__t)+
' </dt><dd class="success"> '+
((__t=( zone ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( datetime ) { 
__p+=' <dt>'+
((__t=(i18n.tc('ControlAccessories', 'Last communication: ')))==null?'':__t)+
' </dt><dd class="success"> '+
((__t=( datetime ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <dt>'+
((__t=(i18n.tc('ControlAccessories', 'Serial number: ')))==null?'':__t)+
' </dt><dd class="success"> '+
((__t=( getId ))==null?'':__t)+
'</dd> ';
 if ( level ) { 
__p+=' <dt>'+
((__t=(i18n.tc('ControlAccessories', 'Battery level: ')))==null?'':__t)+
' </dt><dd class="success"> '+
((__t=( level ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl> ';
 if ( hasConfig ) { 
__p+=' <hr><h5> '+
((__t=(i18n.tc('ControlAccessories', 'Select configuration ')))==null?'':__t)+
' </h5><select id="select-input" data-input="select-input"><option value="" selected="selected" disabled="disabled" hidden> '+
((__t=( getConfig ))==null?'':__t)+
' </option><option value="opt-1">'+
((__t=(i18n.tc('ControlAccessories', 'DigiHeat 8')))==null?'':__t)+
'</option><option value="opt-2">'+
((__t=(i18n.tc('ControlAccessories', 'Orion 700')))==null?'':__t)+
'</option></select> ';
 } 
__p+=' ';
 if ( hasZoneSetting ) { 
__p+=' <hr><h5> '+
((__t=(i18n.tc('ControlAccessories', 'Assign to zone')))==null?'':__t)+
' </h5><select id="select-zone-input" data-input="select-zone-input"> ';
 if ( zone ) { 
__p+=' <option value="" selected="selected" disabled="disabled" hidden>'+
((__t=(i18n.tc('ControlAccessories', 'Zone ')))==null?'':__t)+
' '+
((__t=( zone ))==null?'':__t)+
'</option> ';
 } else { 
__p+=' <option value="" selected="selected" disabled="disabled" hidden>'+
((__t=(i18n.tc('ControlAccessories', 'Choose zone here')))==null?'':__t)+
'</option> ';
 } 
__p+=' <option value="1">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 1 ')))==null?'':__t)+
' </option><option value="2">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 2 ')))==null?'':__t)+
' </option><option value="3">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 3 ')))==null?'':__t)+
' </option><option value="4">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 4 ')))==null?'':__t)+
' </option><option value="5">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 5 ')))==null?'':__t)+
' </option><option value="6">'+
((__t=(i18n.tc('ControlAccessories', 'Zone 6 ')))==null?'':__t)+
' </option></select> ';
 } 
__p+=' <hr><p data-text="accessory-error" class="error" hidden></p><span>DEFA Home '+
((__t=( term ))==null?'':__t)+
' '+
((__t=( type ))==null?'':__t)+
'</span></div><hr><div class="align-right"><fieldset class="button-wrap"><button data-click="close">'+
((__t=(i18n.tc('ControlAccessories', 'Close')))==null?'':__t)+
'</button> <button type="button" data-click="remove">'+
((__t=(i18n.tc('ControlAccessories', 'Remove')))==null?'':__t)+
'</button></fieldset></div></div>';
}
return __p;
};
